import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import "./errorContainer.css";

const ErrorContainer = ({
  message = "An error occurred, try reloading!",
  onReload,
  id,
  hasFixedHeight = true,
  hasBackground = true,
  ...rest
}) => {
  return (
    <div
      className={
        "error-container " +
        (hasFixedHeight ? "error-container-200 " : "") +
        (hasBackground ? "error-container-bg " : "")
      }
      id={id}
      {...rest}
    >
      <div>
        <Typography align="center" variant="body1">
          {message}
        </Typography>
        <Button
          id={`btn-reload-${id}`}
          className="button-reload"
          onClick={onReload}
          variant="contained"
          color="primary"
        >
          Reload
        </Button>
      </div>
    </div>
  );
};

export default ErrorContainer;
